<template>
</template>
<script>
	export default {
		data() {
			let vm = this;
			return {
				element: null,
				resources: {
					zIndex: {
						name: 'zIndex',
						defaultValue: '',
						labelDesc: 'zIndex',
						callback: function () {
							vm.resources.zIndex.defaultValue = this.value;
							vm.element.internal_config.zIndex = this.value;

							vm.element.buildIframe();
						},
					},
          maxWidth: {
            name: 'maxWidth',
            defaultValue: '500',
            min: '200',
            max: '768',
            labelDesc: 'max-width-tablet',
            callback: function () {
              vm.resources.maxWidth.defaultValue = this.value;
              vm.element.internal_config.maxWidth = this.value + 'px';

            },
          },
					fullWidth: {
						name: 'fullWidth',
						defaultValue: '',
						labelDesc: 'full-width',
						callback: function () {
							vm.resources.fullWidth.defaultValue = this.value;
							vm.element.internal_config.fullWidth = this.value;

							vm.element.buildIframe();
						},
					},
					inlineHtml: {
						name: 'inlineHtml',
						defaultValue: '',
						labelDesc: 'inline-html',
						callback: function () {
							vm.resources.inlineHtml.defaultValue = this.value;
							vm.element.internal_config.inlineHtml = this.value;

							vm.element.buildIframe();
						},
					},
					embedText: {
						name: 'embedText',
						defaultValue: '',
						labelDesc: 'embed-url',
						canRemove: false,
						callback: function () {
							vm.resources.embedText.defaultValue = this.value;
							vm.element.internal_config.src = this.value;

							vm.element.buildIframe();
						},
					},
					textarea: {
						name: 'textarea',
						defaultValue: '',
						labelDesc: 'embed-doc',
						canRemove: false,
						callback: function () {
							vm.resources.textarea.defaultValue = this.value;
							vm.element.internal_config.content = this.value;

							vm.element.buildIframe();
						},
					},
					width: {
						name: 'width',
						defaultValue: '300',
						min: '50',
						max: '1000',
						labelDesc: 'width',
						callback: function () {
							vm.resources.width.defaultValue = this.value;
							vm.element.internal_config.width = this.value + 'px';
						},
					},
					height: {
						name: 'height',
						defaultValue: '300',
						min: '20',
						max: '20000',
						labelDesc: 'height',
						callback: function () {
							vm.resources.height.defaultValue = this.value;
							vm.element.internal_config.height = this.value + 'px';
						},
					},
					minHeight: {
						name: 'minHeight',
						defaultValue: '50',
						min: '20',
						max: '10000',
						labelDesc: 'minHeight',
						callback: function () {
							vm.resources.minHeight.defaultValue = this.value;
							vm.element.internal_config.minHeight = this.value + 'px';
						},
					},
					border: {
						name: 'border',
						defaultValue: '0 none #000000',
						min: '0',
						max: '50',
						labelDesc: 'border',
						callback: function () {
							let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

							vm.resources.border.defaultValue = value;
							vm.element.internal_config.border = value;
						},
					},
					borderRadius: {
						name: 'borderRadius',
						defaultValue: '0 0 0 0',
						min: '0',
						max: '360',
						labelDesc: 'borderRadius',
						callback: function () {

							let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

							vm.resources.borderRadius.defaultValue = value;
							vm.element.internal_config.borderRadius = value;
						},
					},
					padding: {
						name: 'padding',
						defaultLeft: '15',
						defaultTop: '15',
						defaultRight: '15',
						defaultBottom: '15',
						min: '0',
						max: '100',
						labelDesc: 'padding',
						callback: function () {
							vm.resources.padding.defaultLeft = this.l;
							vm.element.internal_config.paddingLeft = this.l + 'px';

							vm.resources.padding.defaultTop = this.t;
							vm.element.internal_config.paddingTop = this.t + 'px';

							vm.resources.padding.defaultRight = this.r;
							vm.element.internal_config.paddingRight = this.r + 'px';

							vm.resources.padding.defaultBottom = this.b;
							vm.element.internal_config.paddingBottom = this.b + 'px';
						},
					},
				}
			}
		},
		methods: {
			setMinValuesData(resource, value) {
				this.resources[resource].min = parseInt(value);
			},
			setValuesData(data) {
				this.element = data;

				this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);

				this.resources.zIndex.defaultValue = data.internal_config.zIndex;

				this.resources.fullWidth.defaultValue = data.internal_config.fullWidth;
				this.resources.inlineHtml.defaultValue = data.internal_config.inlineHtml;

				this.resources.embedText.defaultValue = data.internal_config.src;
				this.resources.textarea.defaultValue = data.internal_config.content;
				this.resources.width.defaultValue = parseInt(data.internal_config.width);
				this.resources.height.defaultValue = parseInt(data.internal_config.height);
				this.resources.minHeight.defaultValue = parseInt(data.internal_config.minHeight);

				this.resources.border.defaultValue = data.internal_config.border;
				this.resources.borderRadius.defaultValue = data.internal_config.borderRadius;

				this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
				this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
				this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
				this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);
			},
			getValuesData() {
				return this.resources;
			}
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Iframe/Resources.vue